export default __webpack_public_path__ + "static/media/game-type-02.c2f4895b.png";